import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, timer } from 'rxjs';
import { first, map, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { UtilsService } from 'src/app/core/service/utils.service';
import { BoardServiceService } from '../../services/board-service.service';
import { BoardMainScreenService } from '../board-main-screen/board-main-screen.service';
import moment from 'moment';
import { REVENUEHISTORYDATA } from 'src/app/pages/dashboard/data';

@Component({
  selector: 'app-times-info-top-bar-card',
  templateUrl: './times-info-top-bar-card.component.html',
  styleUrls: ['./times-info-top-bar-card.component.scss']
})
export class TimesInfoTopBarCardComponent implements OnInit,OnDestroy {
  destroy$: Subject<any> = new Subject<any>();
  @Input() task:any;
  loggedInUser: any = {};
  /*time tracking */
  trackingTotal: string = '';
  trackingTotalUpdate: string = '00:00:00';
  trackingTotalRaw: number;
  trackingTotalRawBeginWith: number;
  trackingTotalInterval: any = null;
  running: boolean = false;
  
  lastTrackStart: Date | null = null;

  loading:boolean = false;

  timerSubscription: Subscription; 

  constructor(
    public translateService: TranslateService,
    private authService: AuthenticationService,
    private boardService: BoardServiceService,
    public boardMainScreen: BoardMainScreenService,
    public utilSrv: UtilsService,
    protected router: Router,
  ) { }

  ngOnInit(): void {
    this.loggedInUser = this.authService.currentUser;

    if (this.task?.trackingRunning == true) {
      const end = new Date();
      const sum = moment(end).diff(this.task?.trackingLastStart, 'seconds');
      this.trackingTotal = this.parseSeconds(Number(this.task?.trackingTotal) + Number(sum));
      this.trackingTotalRaw = (Number(this.task?.trackingTotal) + Number(sum));
      this.trackingTotalRawBeginWith = Number(this.task?.trackingTotal);
      this.lastTrackStart =this.task?.trackingLastStart;
      this.activeTrackingInterval();
    } else {
      let total = this.parseSeconds(this.task?.trackingTotal)
      this.trackingTotal = total;
    }
    this.running = this.task?.trackingRunning;

    this.boardMainScreen.trackingRunning.pipe(
      takeUntil(this.destroy$),
    ).subscribe((value: any) => {
      if(this.task.id == value?.id){
        this.getTask()
      }

    })

  }

  ngOnDestroy() {
    this.destroy$.next(0);
    this.destroy$.unsubscribe();

    if (this.trackingTotalInterval)
      clearInterval(this.trackingTotalInterval);
  }

  desactiveTrackingInterval() {
    if (this.trackingTotalInterval)
      clearInterval(this.trackingTotalInterval);
  }

  activeTrackingInterval() {
    this.trackingTotalInterval = setInterval(() => {
      this.trackingTotalRaw = this.trackingTotalRawBeginWith + moment(new Date()).diff(this.lastTrackStart, 'seconds');
      this.trackingTotal = this.parseSeconds(this.trackingTotalRaw);
    }, 1000);
  }

  parseSeconds(secondsBackend: number) {
    let totalSeconds = secondsBackend;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;
    return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
  }

  getTask() {
    this.desactiveTrackingInterval();
    this.loading = true;

    this.boardService.getTask(+this.task.id).pipe(first()).subscribe((response) => {
      let data = response.data[0];

      if (data.trackingRunning == true) {
        const end = new Date();
        const sum = moment(end).diff(data.trackingLastStart, 'seconds');
        this.trackingTotal = this.parseSeconds(Number(data.trackingTotal) + Number(sum));
        this.trackingTotalRaw = (Number(data.trackingTotal) + Number(sum));
        this.trackingTotalRawBeginWith = Number(data.trackingTotal);
        this.lastTrackStart =data.trackingLastStart;
        this.activeTrackingInterval();
      } else {
        let total = this.parseSeconds(data.trackingTotal)
        this.trackingTotal = total;
      }
      this.running = data.trackingRunning;
      this.task = data;

      //if (data.sprintId != null) this.checkDates(data.sprintId)
      this.task = data
      this.loading = false;


    }, error => { this.utilSrv.toast(`${this.translateService.instant('BOARD.ERROR.LOADTASKS')}: ${error}`, 'error', false), this.loading = false })
  }

  goToProject() {
    this.router.navigate(['projects', this.task.projectId, 'dashboard']);
  }

  goToTask() {
    this.boardMainScreen.closeOverlayTask.next(false);
    this.boardMainScreen.openTaskModalView.next({ taskId: this.task?.id, projectId: this.task.projectId });
  }

  beforeToggle() {
    if (this.task.assignedId != this.loggedInUser?.id) {
      this.utilSrv.confirm('BOARD.TIMESLIST.TOGGLEASK').then((resp: any) => {
        if (resp.isConfirmed) {
          this.toggle();
        }
      })
    } else {
      this.toggle();
    }

  }

  toggle() {
    this.boardService.toggleTask(this.task?.id).pipe(first()).subscribe((response) => {
      this.trackingTotalRaw = response.data[0].accumulatedSum;
      this.trackingTotalRawBeginWith = response.data[0].accumulatedSum;
      let total = this.parseSeconds(response.data[0].accumulatedSum)
      this.trackingTotal = total;

      if (response.data[0].started) {
        this.running = true;
        this.lastTrackStart =response.data[0].trackingLastStart;
        this.activeTrackingInterval();
        this.boardMainScreen.trackingRunning.next({ id: this.task.id, status: true, total: this.trackingTotalRaw, trackingLastStart: response.data[0].trackingLastStart });
        this.task.trackingRunning = true;
      } else {
        this.running = false;
        this.desactiveTrackingInterval();
        this.boardMainScreen.trackingRunning.next({ id: this.task.id, status: false, total: this.trackingTotalRaw, trackingLastStart: response.data[0].trackingLastStart });
        this.task.trackingRunning = false;
      }
      this.boardMainScreen.reloadCard.next(this.task?.id);
    }, (error: any) => {
      if (error == 'TASK_USER_ALREADY_ACTIVE_PERIOD') {
        this.utilSrv.toast(this.translateService.instant('BOARD.ACTIVE'), 'warning', false);
      } else {
        this.utilSrv.toast(`Task: ${error}`, 'error', false);
      }
    });
  }


}
